import Vue from 'vue'
import App from './Principal.vue'
import router from './router'
import store from './store'
import VueAnalytics from 'vue-analytics';
//import VueGtag from "vue-gtag";
import "vue-material-design-icons/styles.css"
import './assets/scss/estilo.css';

// import ArrowLeft from "vue-material-design-icons/ArrowLeft.vue";
import ArrowLeft from "vue-material-design-icons/KeyboardBackspace.vue";
import ArrowRight from "vue-material-design-icons/ArrowRight.vue";
import Carrinho from "vue-material-design-icons/ShoppingOutline.vue";
import Facebook from "vue-material-design-icons/Facebook.vue";
import Instagram from "vue-material-design-icons/Instagram.vue";
import Menu from "vue-material-design-icons/Menu.vue";
import Pesquisa from "vue-material-design-icons/Magnify.vue";
import Whatsapp from "vue-material-design-icons/Whatsapp.vue";
Vue.component("mdi-retornar", ArrowLeft);
Vue.component("mdi-avancar", ArrowRight);
Vue.component("mdi-carrinho", Carrinho);
Vue.component("mdi-facebook", Facebook);
Vue.component("mdi-instagram", Instagram);
Vue.component("mdi-menu", Menu);
Vue.component("mdi-pesquisa", Pesquisa);
Vue.component("mdi-whatsapp", Whatsapp);


// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: ['UA-55888081-5','AW-706087018'],
  router
});

// Vue.use(VueGtag, {
//   config: {id: 'UA-55888081-5'},
//   includes: [
//     {id: 'AW-706087018'}
//   ]
// },
// router);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
